import React from "react";
import { Award } from "lucide-react";

/**
 * FoundingBadge — the permanent #NN chip shown to Founding 250 members.
 * Renders nothing if `number` is missing/falsy, so it can be safely
 * dropped into any surface (profile, algorithm report, comment, etc.)
 * without a guard at the call-site.
 */
export function FoundingBadge({ number, size = "md", className = "" }) {
  if (!number) return null;

  const sizeMap = {
    sm: {
      wrap: "px-2 py-0.5 gap-1",
      text: "text-[10px]",
      num: "text-[11px]",
      icon: 10,
    },
    md: {
      wrap: "px-2.5 py-1 gap-1.5",
      text: "text-[11px]",
      num: "text-[12px]",
      icon: 12,
    },
    lg: {
      wrap: "px-3.5 py-1.5 gap-2",
      text: "text-[12px]",
      num: "text-[14px]",
      icon: 14,
    },
  };
  const s = sizeMap[size] || sizeMap.md;

  return (
    <span
      className={`inline-flex items-center rounded-full bg-[#0B1220] text-white font-bold tracking-tight ${s.wrap} ${className}`}
      data-testid={`founding-badge-${number}`}
      title={`Founding Member #${number} — one of the first 250 on Wikificial`}
    >
      <Award size={s.icon} className="text-[#F97316]" strokeWidth={2.5} />
      <span className={`uppercase tracking-[0.14em] ${s.text}`}>Founding</span>
      <span className={`font-mono tabular-nums ${s.num}`}>#{number}</span>
    </span>
  );
}
